export default {
  inforList_information:'09Web-智门户资讯',
  inforList_information_list:'0901Web-显示资讯列表',
  inforList_check_information:'0902Web-查看资讯'
}
